import React, { lazy } from 'react';

// project import
import MainLayout from 'layout/MainLayout';
import Loadable from 'component/Loadable';
import StoreLayout from 'views/Stores/Table/layout';
import EditStore from 'views/Team/updateStore';
import ProtectedRoute from './ProtectedRoute';
import StorePage from 'views/Stores/Insight/storePage';
// import VideoPage from 'views/Stores/Insight/videoPage/videoPage';

import NotFound from 'views/NotFound/NotFound';
import VideoPage from 'views/Stores/Insight/videoPage/videoPage';
//import Settings from 'views/Stores/Insight/settings/settings';
import UserProfile from 'views/UserProfile';
// import Settings from 'views/Settings';
import EvidencePage from 'views/Stores/Insight/evidencePage/evidence';

const Insight = Loadable(lazy(() => import('../views/Insights')));

const Brands = Loadable(lazy(() => import('../views/Brands')));

const Customers = Loadable(lazy(() => import('../views/Customers')));

const Team = Loadable(lazy(() => import('../views/Team')));

const UtilsTypography = Loadable(lazy(() => import('../views/Utils/Typography')));

const SamplePage = Loadable(lazy(() => import('../views/SamplePage')));

// ==============================|| MAIN ROUTES ||============================== //

const MainRoutes = {
  path: '/main',
  element: <ProtectedRoute element={<MainLayout />} />,
  children: [
    {
      path: 'insights',
      element: <Insight />
    },
    {
      path: 'stores/layout',
      element: <StoreLayout />
    },
    {
      path: 'brands',
      element: <Brands />
    },
    {
      path: 'stores',
      element: <Customers />
    },
    {
      path: 'stores/storeinsight',
      element: <StorePage />
    },
    {
      path: 'stores/storevideo',
      element: <VideoPage />
    },
    // {
    //   path: '/main/stores/storesettings',
    //   element: <Settings />
    // },
    {
      path: '/main/stores/evidence',
      element: <EvidencePage />
    },
    {
      path: '/main/team',
      element: <Team />,
      children: [
        {
          path: 'edit/:id',
          element: <EditStore />
        }
      ]
    },
    { path: 'utils/util-typography', element: <UtilsTypography /> },
    { path: 'sample-page', element: <SamplePage /> },
    {
      path: 'storePage',
      element: <StorePage />
    },
    {
      path: 'profile',
      element: <UserProfile />
    },
    // {
    //   path: 'settings',
    //   element: <Settings />
    // },
    { path: '*', element: <NotFound btn="Go back" flag="1" /> }
  ]
};

export default MainRoutes;
